import { type JSX } from 'react/jsx-runtime';

export const SearchCardIllustrationLight = (): JSX.Element => (
	<svg
		height="128"
		width="100%"
		fill="none"
		preserveAspectRatio="xMinYMin slice"
		role="presentation"
		viewBox="0 0 335 128"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_8794_181898)">
			<path fill="#DDDEE1" d="M0 8a8 8 0 0 1 8-8h319a8 8 0 0 1 8 8v120H0V8Z" />
			<g filter="url(#filter0_f_8794_181898)" opacity={0.1}>
				<g clipPath="url(#paint0_angular_8794_181898_clip_path)" data-figma-skip-parse="true">
					<foreignObject
						width={2059.7}
						height={2059.7}
						x={-1029.85}
						y={-1029.85}
						transform="matrix(0 .0335 -.123 0 146 46.5)"
					>
						<div
							style={{
								background:
									'conic-gradient(from 90deg,#fca700 0deg,#fca700 1.8deg,#81b435 70.2deg,#1868db 128.853deg,#bf63f3 223.2deg,#f0f1f2 316.8deg,#fca700 352.8deg,#fca700 360deg)',
								height: '100%',
								width: '100%',
								opacity: 1,
							}}
						/>
					</foreignObject>
				</g>
				<path
					d="M23 46.5C23 27.998 37.998 13 56.5 13h179c18.502 0 33.5 14.998 33.5 33.5 0 18.501-14.998 33.5-33.5 33.5h-179C37.998 80 23 65.001 23 46.5Z"
					data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0049999998882412910},{"color":{"r":0.50968009233474731,"g":0.70840001106262207,"b":0.21160000562667847,"a":1.0},"position":0.19499999284744263},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.35792604088783264},{"color":{"r":0.74901962280273438,"g":0.38823530077934265,"b":0.95294117927551270,"a":1.0},"position":0.62000000476837158},{"color":{"r":0.94117647409439087,"g":0.94509804248809814,"b":0.94901961088180542,"a":1.0},"position":0.87999999523162842},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.98000001907348633}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0049999998882412910},{"color":{"r":0.50968009233474731,"g":0.70840001106262207,"b":0.21160000562667847,"a":1.0},"position":0.19499999284744263},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.35792604088783264},{"color":{"r":0.74901962280273438,"g":0.38823530077934265,"b":0.95294117927551270,"a":1.0},"position":0.62000000476837158},{"color":{"r":0.94117647409439087,"g":0.94509804248809814,"b":0.94901961088180542,"a":1.0},"position":0.87999999523162842},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.98000001907348633}],"transform":{"m00":1.5063156207388226e-14,"m01":-246.0,"m02":269.0,"m10":67.0,"m11":4.1025668105765245e-15,"m12":13.0},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
				/>
			</g>
			<mask
				id="path-3-outside-1_8794_181898"
				width={884}
				height={40}
				x={24}
				y={34}
				fill="#000"
				maskUnits="userSpaceOnUse"
			>
				<path fill="#fff" d="M24 34h884v40H24z" />
				<path d="M26 42a6 6 0 0 1 6-6h867.74a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6H32a6 6 0 0 1-6-6V42Z" />
			</mask>
			<path
				fill="#fff"
				d="M26 42a6 6 0 0 1 6-6h867.74a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6H32a6 6 0 0 1-6-6V42Z"
			/>
			<g
				clipPath="url(#paint1_angular_8794_181898_clip_path)"
				data-figma-skip-parse="true"
				mask="url(#path-3-outside-1_8794_181898)"
			>
				<foreignObject
					width={2222.22}
					height={2222.22}
					x={-1111.11}
					y={-1111.11}
					transform="matrix(0 .018 -.43987 0 465.87 54)"
				>
					<div
						style={{
							background:
								'conic-gradient(from 90deg,#d0ad13 0deg,#81b435 43.2deg,#0469fe 117deg,#bf63f3 203.4deg,#e2e3e4 266.4deg,#ffa900 334.8deg,#d0ad13 360deg)',
							height: '100%',
							width: '100%',
							opacity: 1,
						}}
					/>
				</foreignObject>
			</g>
			<path
				d="M32 36v2h867.74v-4H32v2Zm873.74 6h-2v24h4V42h-2Zm-6 30v-2H32v4h867.74v-2ZM26 66h2V42h-4v24h2Zm6 6v-2a4 4 0 0 1-4-4h-4a8 8 0 0 0 8 8v-2Zm873.74-6h-2a4 4 0 0 1-4 4v4a8 8 0 0 0 8-8h-2Zm-6-30v2a4 4 0 0 1 4 4h4a8 8 0 0 0-8-8v2ZM32 36v-2a8 8 0 0 0-8 8h4a4 4 0 0 1 4-4v-2Z"
				data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.50968009233474731,"g":0.70840001106262207,"b":0.21160000562667847,"a":1.0},"position":0.11999999731779099},{"color":{"r":0.016105264425277710,"g":0.41271612048149109,"b":0.99826967716217041,"a":1.0},"position":0.32499998807907104},{"color":{"r":0.74901962280273438,"g":0.38823530077934265,"b":0.95294117927551270,"a":1.0},"position":0.56499999761581421},{"color":{"r":0.88627451658248901,"g":0.89019608497619629,"b":0.89411765336990356,"a":1.0},"position":0.74000000953674316},{"color":{"r":1.0,"g":0.66274511814117432,"b":0.0,"a":1.0},"position":0.93000000715255737}],"stopsVar":[{"color":{"r":0.50968009233474731,"g":0.70840001106262207,"b":0.21160000562667847,"a":1.0},"position":0.11999999731779099},{"color":{"r":0.016105264425277710,"g":0.41271612048149109,"b":0.99826967716217041,"a":1.0},"position":0.32499998807907104},{"color":{"r":0.74901962280273438,"g":0.38823530077934265,"b":0.95294117927551270,"a":1.0},"position":0.56499999761581421},{"color":{"r":0.88627451658248901,"g":0.89019608497619629,"b":0.89411765336990356,"a":1.0},"position":0.74000000953674316},{"color":{"r":1.0,"g":0.66274511814117432,"b":0.0,"a":1.0},"position":0.93000000715255737}],"transform":{"m00":2.5558914785506204e-05,"m01":-879.7402343750,"m02":905.7402343750,"m10":36.0,"m11":2.8805884539906401e-06,"m12":36.0},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
				mask="url(#path-3-outside-1_8794_181898)"
			/>
			<g
				clipPath="url(#paint2_angular_8794_181898_clip_path)"
				data-figma-skip-parse="true"
				mask="url(#path-3-outside-1_8794_181898)"
			>
				<foreignObject
					width={2222.22}
					height={2222.22}
					x={-1111.11}
					y={-1111.11}
					transform="matrix(0 .018 -.43987 0 465.87 54)"
				>
					<div
						style={{
							background:
								'conic-gradient(from 90deg,#d0ad13 0deg,#81b435 43.2deg,#0469fe 117deg,#bf63f3 203.4deg,#e2e3e4 266.4deg,#ffa900 334.8deg,#d0ad13 360deg)',
							height: '100%',
							width: '100%',
							opacity: 1,
						}}
					/>
				</foreignObject>
			</g>
			<path
				d="M32 36v2h867.74v-4H32v2Zm873.74 6h-2v24h4V42h-2Zm-6 30v-2H32v4h867.74v-2ZM26 66h2V42h-4v24h2Zm6 6v-2a4 4 0 0 1-4-4h-4a8 8 0 0 0 8 8v-2Zm873.74-6h-2a4 4 0 0 1-4 4v4a8 8 0 0 0 8-8h-2Zm-6-30v2a4 4 0 0 1 4 4h4a8 8 0 0 0-8-8v2ZM32 36v-2a8 8 0 0 0-8 8h4a4 4 0 0 1 4-4v-2Z"
				data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.50968009233474731,"g":0.70840001106262207,"b":0.21160000562667847,"a":1.0},"position":0.11999999731779099},{"color":{"r":0.016105264425277710,"g":0.41271612048149109,"b":0.99826967716217041,"a":1.0},"position":0.32499998807907104},{"color":{"r":0.74901962280273438,"g":0.38823530077934265,"b":0.95294117927551270,"a":1.0},"position":0.56499999761581421},{"color":{"r":0.88627451658248901,"g":0.89019608497619629,"b":0.89411765336990356,"a":1.0},"position":0.74000000953674316},{"color":{"r":1.0,"g":0.66274511814117432,"b":0.0,"a":1.0},"position":0.93000000715255737}],"stopsVar":[{"color":{"r":0.50968009233474731,"g":0.70840001106262207,"b":0.21160000562667847,"a":1.0},"position":0.11999999731779099},{"color":{"r":0.016105264425277710,"g":0.41271612048149109,"b":0.99826967716217041,"a":1.0},"position":0.32499998807907104},{"color":{"r":0.74901962280273438,"g":0.38823530077934265,"b":0.95294117927551270,"a":1.0},"position":0.56499999761581421},{"color":{"r":0.88627451658248901,"g":0.89019608497619629,"b":0.89411765336990356,"a":1.0},"position":0.74000000953674316},{"color":{"r":1.0,"g":0.66274511814117432,"b":0.0,"a":1.0},"position":0.93000000715255737}],"transform":{"m00":2.5558914785506204e-05,"m01":-879.7402343750,"m02":905.7402343750,"m10":36.0,"m11":2.8805884539906401e-06,"m12":36.0},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
				mask="url(#path-3-outside-1_8794_181898)"
			/>
			<path
				fill="#292A2E"
				d="M33.412 48a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6h-12a6 6 0 0 1-6-6V48Z"
			/>
			<path
				fill="#fff"
				fillRule="evenodd"
				d="M39.006 52.798a5.209 5.209 0 0 0 5.213 5.205c.924 0 1.792-.24 2.545-.661l3.069 3.064 1.985-1.982-3.063-3.058a5.174 5.174 0 0 0 .677-2.568 5.209 5.209 0 0 0-5.213-5.204 5.209 5.209 0 0 0-5.213 5.204Zm2.005 0a3.206 3.206 0 0 0 3.208 3.203 3.206 3.206 0 0 0 3.208-3.203 3.205 3.205 0 0 0-3.208-3.202 3.206 3.206 0 0 0-3.208 3.203Z"
				clipRule="evenodd"
			/>
			<path fill="#F0F1F2" d="M64.824 51h192v6h-192z" />
			<rect width={83.829} height={29.952} x={24} y={82} fill="#fff" rx={4} />
			<path
				fill="#505258"
				fillRule="evenodd"
				d="M39.599 92.454a2.216 2.216 0 1 0 0 4.432 2.216 2.216 0 0 0 0-4.432Zm-3.545 2.216a3.545 3.545 0 1 1 7.09 0 3.545 3.545 0 0 1-7.09 0Zm-1.773 7.977a3.324 3.324 0 0 1 3.324-3.324h3.988a3.324 3.324 0 0 1 3.324 3.324v1.772h-1.33v-1.772a1.994 1.994 0 0 0-1.994-1.995h-3.988a1.994 1.994 0 0 0-1.994 1.995v1.772h-1.33v-1.772Z"
				clipRule="evenodd"
			/>
			<path fill="#F0F1F2" d="M54.523 95.215h37v6h-37z" />
			<rect width={85.314} height={29.952} x={114.828} y={82} fill="#fff" rx={4.608} />
			<path
				fill="#1868DB"
				d="M125.463 92.425a4.311 4.311 0 0 1 4.312-4.312h9.102a4.311 4.311 0 0 1 4.311 4.312v9.102a4.312 4.312 0 0 1-4.311 4.312h-9.102a4.312 4.312 0 0 1-4.312-4.312v-9.102Z"
			/>
			<path
				fill="#fff"
				d="M138.81 98.931c-2.982-1.442-3.854-1.658-5.111-1.658-1.474 0-2.731.614-3.854 2.338l-.184.282c-.151.232-.184.315-.184.414 0 .1.05.182.234.298l1.894 1.177c.1.067.184.1.268.1.1 0 .167-.05.268-.199l.302-.464c.469-.713.888-.945 1.424-.945.469 0 1.022.133 1.709.464l1.978.928c.201.1.419.05.519-.182l.938-2.056c.101-.232.034-.38-.201-.497Zm-8.697-3.63c2.983 1.442 3.855 1.657 5.111 1.657 1.475 0 2.732-.613 3.855-2.337l.184-.282c.151-.232.184-.315.184-.415 0-.099-.05-.182-.234-.298l-1.894-1.177a.49.49 0 0 0-.268-.1c-.101 0-.168.05-.268.2l-.302.464c-.469.713-.888.945-1.424.945-.469 0-1.022-.133-1.709-.465l-1.978-.928c-.201-.1-.419-.05-.519.183l-.939 2.055c-.1.232-.033.381.201.498Z"
			/>
			<path fill="#F0F1F2" d="M148.506 93.977h41v6h-41z" />
			<rect width={137} height={30} x={207.143} y={82} fill="#fff" rx={4.608} />
			<path
				fill="#fff"
				d="M212.367 91.683a5.318 5.318 0 0 1 5.318-5.318h10.635a5.318 5.318 0 0 1 5.318 5.318v10.635a5.318 5.318 0 0 1-5.318 5.318h-10.635a5.318 5.318 0 0 1-5.318-5.318V91.683Z"
			/>
			<g clipPath="url(#clip1_8794_181898)">
				<path
					fill="#E01E5A"
					d="M219.568 99.095a1.38 1.38 0 0 1-1.382 1.381 1.38 1.38 0 0 1-1.381-1.381 1.38 1.38 0 0 1 1.381-1.382h1.382v1.382Zm.691 0a1.38 1.38 0 0 1 1.382-1.382 1.38 1.38 0 0 1 1.382 1.382v3.454a1.381 1.381 0 1 1-2.764 0v-3.454Z"
				/>
				<path
					fill="#36C5F0"
					d="M221.64 93.545a1.38 1.38 0 0 1-1.382-1.382 1.38 1.38 0 0 1 1.382-1.382 1.38 1.38 0 0 1 1.381 1.382v1.382h-1.381Zm0 .701a1.38 1.38 0 0 1 1.381 1.382 1.38 1.38 0 0 1-1.381 1.382h-3.465a1.38 1.38 0 1 1 0-2.764h3.465Z"
				/>
				<path
					fill="#2EB67D"
					d="M227.179 95.628a1.38 1.38 0 0 1 1.382-1.382 1.38 1.38 0 1 1 0 2.764h-1.382v-1.382Zm-.691 0a1.38 1.38 0 0 1-1.382 1.382 1.38 1.38 0 0 1-1.381-1.382v-3.465a1.38 1.38 0 0 1 1.381-1.382 1.38 1.38 0 0 1 1.382 1.382v3.465Z"
				/>
				<path
					fill="#ECB22E"
					d="M225.106 101.167a1.38 1.38 0 0 1 1.382 1.382 1.38 1.38 0 1 1-2.763 0v-1.382h1.381Zm0-.691a1.38 1.38 0 0 1-1.381-1.381 1.38 1.38 0 0 1 1.381-1.382h3.465a1.38 1.38 0 1 1 0 2.763h-3.465Z"
				/>
			</g>
			<path fill="#F0F1F2" d="M238.955 93.736h94.553v6.53h-94.553z" />
			<path
				fill="#292A2E"
				d="M10.827 37.117c-.262.157-4.801-1.205-3.561-1.729.414-.254.815-.171.97.303.09-.87 1.001.419 1.398.181-.175-.636 1.116.807.85.135 4.833-.06 14.907 7.167 2.792 2.063 1.174-.129.043-.514-.485-.444.801.887-1.46-.079-1.884-.403.691.102-.475-.624-.078-.108l-.002.002ZM19.257 30.723c-.636-.118-3.512-4.796-3.866-5.252-.601-1.086.854-.985 1.135-.088.126.163.602 1.45.87.958 1.256.427 1.54 2.657 2.595 2.925-.153.27.236.663.16.847.31.005.506.446.433.475 1.386 1.254-.2 2.334-.994.681-.051.06-.427-.26-.333-.542v-.004ZM34.997 24.576c.606.792.528.026.229-.358-.48.583-.555-.927-.403-1.293.04.161.31.22.248-.112-.633.22-1.383-3.976.293-1.978.008.072-.513.097-.337.183.776-.13.317.521.283.706.413.002.055.173.233.222.523-.22-.25.84.263.59.987.972.15 2.859 1.028 3.603-.856.495.987 3.589-.965 2.379-.597-1.331-.983-2.42-.872-3.942ZM24.315 16.465c1.229-.315 1.376 2.569 2.014 3.36.888.96 4.98 11.2 2.076 8.515-1.214-3.105-2.716-5.529-3.744-9.4-.21-.625-1.252-2.57-.346-2.475ZM17.513 47.082c.888 1.082 1.745-.231 2.57.66 1.292 1.706-8.088 2.109-8.035.382.248-1.442 4.883-.42 5.465-1.042Z"
			/>
		</g>
		<defs>
			<clipPath id="paint0_angular_8794_181898_clip_path">
				<path d="M23 46.5C23 27.998 37.998 13 56.5 13h179c18.502 0 33.5 14.998 33.5 33.5 0 18.501-14.998 33.5-33.5 33.5h-179C37.998 80 23 65.001 23 46.5Z" />
			</clipPath>
			<clipPath id="paint1_angular_8794_181898_clip_path">
				<path
					d="M32 36v2h867.74v-4H32v2Zm873.74 6h-2v24h4V42h-2Zm-6 30v-2H32v4h867.74v-2ZM26 66h2V42h-4v24h2Zm6 6v-2a4 4 0 0 1-4-4h-4a8 8 0 0 0 8 8v-2Zm873.74-6h-2a4 4 0 0 1-4 4v4a8 8 0 0 0 8-8h-2Zm-6-30v2a4 4 0 0 1 4 4h4a8 8 0 0 0-8-8v2ZM32 36v-2a8 8 0 0 0-8 8h4a4 4 0 0 1 4-4v-2Z"
					mask="url(#path-3-outside-1_8794_181898)"
				/>
			</clipPath>
			<clipPath id="paint2_angular_8794_181898_clip_path">
				<path
					d="M32 36v2h867.74v-4H32v2Zm873.74 6h-2v24h4V42h-2Zm-6 30v-2H32v4h867.74v-2ZM26 66h2V42h-4v24h2Zm6 6v-2a4 4 0 0 1-4-4h-4a8 8 0 0 0 8 8v-2Zm873.74-6h-2a4 4 0 0 1-4 4v4a8 8 0 0 0 8-8h-2Zm-6-30v2a4 4 0 0 1 4 4h4a8 8 0 0 0-8-8v2ZM32 36v-2a8 8 0 0 0-8 8h4a4 4 0 0 1 4-4v-2Z"
					mask="url(#path-3-outside-1_8794_181898)"
				/>
			</clipPath>
			<clipPath id="clip0_8794_181898">
				<path fill="#fff" d="M0 8a8 8 0 0 1 8-8h319a8 8 0 0 1 8 8v120H0V8Z" />
			</clipPath>
			<clipPath id="clip1_8794_181898">
				<path fill="#fff" d="M216.721 90.719h13.294v13.294h-13.294z" />
			</clipPath>
			<filter
				id="filter0_f_8794_181898"
				width={446}
				height={267}
				x={-77}
				y={-87}
				colorInterpolationFilters="sRGB"
				filterUnits="userSpaceOnUse"
			>
				<feFlood floodOpacity={0} result="BackgroundImageFix" />
				<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feGaussianBlur result="effect1_foregroundBlur_8794_181898" stdDeviation={50} />
			</filter>
		</defs>
	</svg>
);
